import * as domtoimage from "src/utils/dom-to-image/dom-to-image";

function mutateDomBeforeScreenshot(element: HTMLElement) {
  function removeSrcSets() {
    const imgs = [...element.querySelectorAll("img[srcset]")];
    const entries = imgs.map((img) => ({
      img,
      srcset: img.getAttribute("srcset"),
    }));

    entries.forEach(({ img }) => {
      img.removeAttribute("srcset");
    });

    return function reset() {
      entries.forEach(({ img, srcset }) => {
        if (srcset === null) {
          return;
        }
        img.setAttribute("srcset", srcset);
      });
    };
  }

  const resets: Array<() => void | undefined> = [];

  try {
    resets.push(removeSrcSets());
  } catch (error) {
    // Ignore potential error
  } finally {
    // Always return the reset function
    // eslint-disable-next-line no-unsafe-finally
    return () => {
      resets.forEach((reset) => reset?.());
    };
  }
}

const downloadImage =
  ({ fileName, fileExt }: { fileName: string; fileExt: string }) =>
  (dataUrl: string) => {
    const link = document.createElement("a");
    link.download = `${fileName}.${fileExt}`;
    link.href = dataUrl;
    link.click();
  };

function copyImageToClipboard(blob: any) {
  return navigator.clipboard.write([
    new ClipboardItem({
      "image/png": blob,
    }),
  ]);
}

export async function savePngScreenshot(
  element: HTMLElement,
  {
    fileName = "Dune",
    domtoimageOptions = {},
  }: {
    fileName?: string;
    domtoimageOptions?: domtoimage.Options;
  } = {}
) {
  let resetDom = () => {};

  try {
    resetDom = mutateDomBeforeScreenshot(element);

    await domtoimage
      .toPng(element, domtoimageOptions)
      .then(downloadImage({ fileName, fileExt: "png" }));
  } finally {
    resetDom();
  }
}

export async function copyPngScreenshotToClipboard(
  element: HTMLElement,
  {
    domtoimageOptions = {},
  }: {
    domtoimageOptions?: domtoimage.Options;
  } = {}
) {
  let resetDom = () => {};

  try {
    resetDom = mutateDomBeforeScreenshot(element);

    await domtoimage
      .toBlob(element, domtoimageOptions)
      .then(copyImageToClipboard);
  } finally {
    resetDom();
  }
}
